/**
 * CallSense 2.0 design tokens + base styles (light + dark), scoped to
 * `.cr-scope`. Mirrors the approved design's `:root` / dark token sets, its
 * Manrope type + tabular numerals, and its base element styles. Follows the
 * app's `.dark` class convention for dark mode. Wrap a section in
 * `className="cr-scope"`, call `useCallsenseFont()` once, and render
 * `<style>{CR_TOKENS_CSS}</style>` once inside.
 */

/** Manrope, loaded the same way the Website Dashboard page loads it. */
export const CALLSENSE_FONT_HREF =
  'https://fonts.googleapis.com/css2?family=Manrope:wght@400;500;600;700;800&display=swap';

export const CR_TOKENS_CSS = `
.cr-scope{--cr-bg:#f4f4f6;--cr-card:#fff;--cr-tx:#18181b;--cr-mut:#71717a;--cr-bd:#e4e4e7;--cr-bd2:#f0f0f2;--cr-sub:#f7f7f8;--cr-sub2:#ececef;--cr-acc:#4f46e5;--cr-accbg:#eef2ff;--cr-ok:#059669;--cr-okbg:#ecfdf5;--cr-warn:#d97706;--cr-warnbg:#fffbeb;--cr-bad:#dc2626;--cr-badbg:#fef2f2;--cr-wa:#16a34a;--cr-sh:0 1px 2px rgba(0,0,0,.04),0 10px 30px -24px rgba(0,0,0,.25);font-family:Manrope,ui-sans-serif,system-ui,-apple-system,"Segoe UI",sans-serif;font-variant-numeric:tabular-nums;-webkit-font-smoothing:antialiased;color:var(--cr-tx)}
.dark .cr-scope{--cr-bg:#0f0f12;--cr-card:#17171c;--cr-tx:#f4f4f5;--cr-mut:#9d9da8;--cr-bd:#2a2a32;--cr-bd2:#222229;--cr-sub:#1e1e24;--cr-sub2:#2a2a32;--cr-acc:#818cf8;--cr-accbg:#272a4a;--cr-ok:#34d399;--cr-okbg:#0f2e25;--cr-warn:#fbbf24;--cr-warnbg:#3a2a0a;--cr-bad:#f87171;--cr-badbg:#3b1414;--cr-wa:#4ade80;--cr-sh:0 1px 2px rgba(0,0,0,.4)}
.cr-scope a{color:var(--cr-acc);text-decoration:none}.cr-scope a:hover{text-decoration:underline}
.cr-scope button{font:inherit}
.cr-scope table{border-collapse:separate;border-spacing:0}
`;
